/** @format */

import { memo } from 'react'
import { CopyBlock, ocean } from 'react-code-blocks'

import styles from 'dir/styles/courses.module.css'

export const _1 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>1 - Инлайн CSS</h2>
    <CopyBlock
      text={`const buttonStyles = {
  display: 'inline-flex',
  margin: '0 4px',
  padding: '8px 24px',
  border: 0,
  borderRadius: 2,
  fontSize: 14,
  fontFamily: 'inherit',
};

const Button = ({ type = 'button', label, disabled }) => (
  <button
    type={type}
    disabled={disabled}
    style={{
      ...buttonStyles,
      backgroundColor: disabled ? '#0000001f' : '#2196f3',
      color: disabled ? '#00000042' : '#ffffff',
    }}
  >
    {label}
  </button>
);`}
      language="javascript"
      showLineNumbers={false}
      theme={ocean}
    />
    <ul className={styles.list}>
      <li className={styles.list__item}>Плохая производительность</li>
      <li className={styles.list__item}>Не масштабируется</li>
      <li className={styles.list__item}>Ограниченные возможности (псевдоэлементы, медиа и т. п.)</li>
      <li className={styles.list__item}>Нет инструментов и сложно дебажить</li>
    </ul>
  </section>
))
